module.exports = __webpack_public_path__ + "static/img/CGZ.72f56c3b.png";